export const JDOODLE_COMPILER_SCRIPT =
  'https://outlier.jdoodle.com/assets/jdoodle-pym.min.js'
export const JDOODLE_COMPILER_KEY = 'text/javascript'

export const DEFAULT_THEME = 'tomorrow_night_bright'
export const THEMES = [DEFAULT_THEME, 'chaos', 'vibrant_ink']
